import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Check, Home } from 'lucide-react';

const Confirmation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const waiverData = location.state?.waiverData;

  if (!waiverData) {
    navigate('/');
    return null;
  }

  const signedDate = new Date(waiverData.signedAt).toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const expiryDate = new Date(new Date(waiverData.signedAt).getTime() + 365 * 24 * 60 * 60 * 1000).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white rounded-lg shadow-md p-8 text-center">
          {/* Success Icon */}
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Check className="w-10 h-10 text-green-600" />
          </div>

          {/* Success Message */}
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Waiver Signed Successfully!
          </h1>
          
          <p className="text-lg text-gray-600 mb-8">
            Thank you, <span className="font-semibold">{waiverData.name}</span>!<br />
            Your digital waiver has been successfully signed and recorded.
          </p>

          {/* Waiver Details */}
          <div className="bg-blue-50 rounded-lg p-6 mb-8">
            <h3 className="text-lg font-semibold text-blue-900 mb-4">
              Waiver Details
            </h3>
            <div className="space-y-2 text-blue-800">
              <p><strong>Signed on:</strong> {signedDate}</p>
              <p><strong>Valid until:</strong> {expiryDate}</p>
              <p><strong>Email:</strong> {waiverData.email}</p>
            </div>
          </div>

          {/* Important Instructions */}
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-8 text-left">
            <div className="flex">
              <div className="ml-3">
                <h3 className="text-sm font-medium text-yellow-800">
                  Important: Show this screen to staff
                </h3>
                <div className="mt-2 text-sm text-yellow-700">
                  <p>
                    Please show this confirmation screen to our staff as proof of your signed waiver.
                    You can also provide your email address if needed.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="space-y-4">
            <button
              onClick={() => navigate('/')}
              className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors flex items-center justify-center"
            >
              <Home className="w-5 h-5 mr-2" />
              Return to Home
            </button>
            
            <button
              onClick={() => window.print()}
              className="w-full bg-gray-200 text-gray-800 py-3 px-4 rounded-lg font-semibold hover:bg-gray-300 transition-colors"
            >
              Print Confirmation
            </button>
          </div>

          {/* Footer Note */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-xs text-gray-500">
              This waiver is valid for one year from the signing date.
              For any questions, please contact our staff.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Confirmation;